// Single source of truth for the comment-pin visibility preference. Both the
// map (MapViewer) and the comments panel eye-icon read this on mount so the
// icon always reflects what's actually on the map, and the preference is
// remembered across projects/sessions. Toggling emits
// 'comments:visibilityChanged' to keep every live surface in sync.
export const COMMENTS_VISIBLE_STORAGE_KEY = 'landscope_comments_visible';
export const readCommentsVisible = () => {
    try {
        const raw = localStorage.getItem(COMMENTS_VISIBLE_STORAGE_KEY);
        if (raw === null)
            return true; // default to visible when no preference saved
        return raw === 'true';
    }
    catch (_a) {
        return true;
    }
};
export const writeCommentsVisible = (visible) => {
    try {
        localStorage.setItem(COMMENTS_VISIBLE_STORAGE_KEY, String(visible));
    }
    catch (_a) {
        // localStorage unavailable (private mode / quota) — preference just won't persist.
    }
};
